import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCycleCode extends Layout {
    sourceCycle: DataSource;
    textboxCycleType: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxMinDate1: Textbox;
    textboxMinDate2: Textbox;
    textboxQuarterDate: Textbox;
    textboxQuarterMonth: Textbox;
}
